module.exports = __webpack_public_path__ + "images/lpage-coins-2.png";